import {
  submitOrders
} from '@/api/order'
// import { setToken, removeToken } from '@/utils/auth'

const order = {
  state: {

  },
  mutations: {
    // SET_EXHIBITION_LIST: (state, data) => {
    //   state.brandId = data.brandId
    //   state.conferenceId = data.conferenceId
    // }
  },
  actions: {
    // 商品详情
    SubmitOrders ({ commit }, dataParams) {
      return new Promise((resolve, reject) => {
        submitOrders(dataParams).then(response => {
          // console.log(response)
          const data = JSON.parse(response.data)
          // console.log(data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default order



// WEBPACK FOOTER //
// ./src/store/modules/order.js